import React, {
  useCallback, useMemo, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Form, Input, Button,
} from 'framework-ui-components';
import ErroreIcon from 'framework-ui-components/Components/Icons/ErroreIcon';
import Actions from '../Actions';
import AccountIcon from '../Icons/AccountIcon';
import { addParamToUrl, getParams } from '../Utils';

const RecuperaPassword = ({ applicationStyle }) => {
  const refRecuperaPasswordForm = useRef();

  const [formState, setFormState] = useState({});
  const [erroreRecuperaPassword, setErroreRecuperaPassword] = useState(false);

  const {
    referer, client,
  } = getParams(window.location.href);

  const generaLinkResettaAltroCodice = useMemo(() => {
    let link = '/ResettaPasswordAltroCodice';
    if (client) {
      link = addParamToUrl(link, `client=${client}`);
    }
    if (referer) {
      link = addParamToUrl(link, `referer=${encodeURIComponent(referer)}`);
    }
    return link;
  }, [client, referer]);

  const generaLinkResettaPassword = useCallback((email) => {
    let link = `#/ResettaPassword?username=${formState.CodiceFiscale}&mailRecupero=${encodeURIComponent(email)}`;
    if (client) {
      link = addParamToUrl(link, `client=${client}`);
    }
    if (referer) {
      link = addParamToUrl(link, `referer=${encodeURIComponent(referer)}`);
    }
    return link;
  }, [client, formState.CodiceFiscale, referer]);

  const recuperaPassword = useCallback(() => {
    if (!refRecuperaPasswordForm.current.isValid) {
      return null;
    }
    return Actions.RecuperaPassword(
      formState.CodiceFiscale,
      client,
      encodeURIComponent(referer),
    ).then(
      (res) => {
        if (res.Success) {
          setErroreRecuperaPassword(false);
          window.location.href = generaLinkResettaPassword(res.Response.Email);
        } else {
          setErroreRecuperaPassword('Il codice fiscale fornito risulta errato');
        }
      },
      (res) => {
        setErroreRecuperaPassword('Errore nel recupero della password');
      },
    );
  }, [client, formState.CodiceFiscale, generaLinkResettaPassword, referer]);

  const handleKeyPress = useCallback((e) => {
    if (e.key === 'Enter') {
      recuperaPassword();
    }
  }, [recuperaPassword]);

  return (
    <div className="account__col account__recuperaPassword">
      <div className="accounts__wrapper">
        <div className="accounts__container">
          <div className="accounts__header">
            {applicationStyle.logo || <AccountIcon />}
          </div>
          <Form ref={refRecuperaPasswordForm} onChange={((x) => setFormState((old) => ({ ...old, ...x })))} stato={formState}>
            <h3>Hai dimenticato la password ?</h3>
            <span>Non preoccuparti capita, ti aiuteremo noi.</span><br /><br />
            <span>Per recuperare la password inserisci il tuo <strong>Codice fiscale</strong></span><br /><br />
            <Input
              title="Codice fiscale"
              name="CodiceFiscale"
              validations={['required']}
              onKeyPress={handleKeyPress}
              autoFocus
              spellCheck="false"
            />
            <div className="accountsForm__actions">
              <div className="login__btnContainer">
                <Button
                  primary
                  className="recuperaPassword__button"
                  disabled={!refRecuperaPasswordForm.current || !refRecuperaPasswordForm.current.isValid}
                  onClick={recuperaPassword}
                >
                  Recupera Password
                </Button>
                {erroreRecuperaPassword && (
                  <div className="effettuaLogin__errore">
                    <ErroreIcon /><span>{erroreRecuperaPassword}</span>
                  </div>
                )}
              </div>
              <br />
              <span>Se possiedi già il codice di sicurezza<br />
                per la modifica della password <Link to={generaLinkResettaAltroCodice}>clicca qui</Link>
              </span><br />
              <br />
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

RecuperaPassword.propTypes = {
  applicationStyle: PropTypes.shape({
    logo: PropTypes.element,
  }).isRequired,
};

export default RecuperaPassword;
